module.exports = __webpack_public_path__ + "img/logo.6bce0094.png";